import type { RecommendationRequestWrapper } from 'autogen/swagger/all';
import { memo } from 'react';
import ProductRecommendation, {
    type ProductRecommendation as ProductRecommendationInterface
} from '../ProductRecommendation';
import useRecommendationModelAsync from '../shared/hooks/useRecommendationModelAsync';

const RecommendationLoader = ({
    model,
    ...restprops
}: {
    model: RecommendationRequestWrapper['recommendationRequest'];
} & Omit<ProductRecommendationInterface, 'model'>) => {
    const { data: resolvedModel, isLoading } = useRecommendationModelAsync(model);

    if (!resolvedModel || isLoading) return null;

    return <ProductRecommendation {...restprops} model={resolvedModel} />;
};

export default memo(RecommendationLoader);
